SlideView = require("views/slide")

class TextSequenceView extends SlideView
  template: require("./template")

  events: ->
    "iostap": "onTap"
    "iostap .btn-done": "submit"

  serialize: ->
    data = super
    data.content = _.compact data.content
    data.hasPrompt = true
    data

  beforeHide: ->
    @trigger("ui", flexibleHeight: false)

  beforeShow: (preventTransition) ->
    @trigger("ui", flexibleHeight: true)

    @setEl @findOne(".steps"), "steps"
    @setEl @findOne(".slide-footer-prompt"), "prompt"
    @setEl @findOne(".btn-up"), "btn-up"
    @setEl @findOne(".btn-down"), "btn-down"

    for child, i in @getEl("steps").children
      child.classList.remove "active"
      @transform child, { opacity: "", transition: "" }

    return unless @getEl("steps")

    @transition @getEl("steps"),
      if preventTransition then "none" else "all 300ms"

    @currentIndex = 0
    @totalLength  = @getEl("steps").children.length
    @showNextStep(true)

  onTap: (e) ->
    if (e?.detail?.clientY) < @el.offsetHeight / 2 and
       @currentIndex > 0 and
       @options.data.canGoBack
      @currentIndex--
      @showNextStep()
    else if @currentIndex < @totalLength - 1
      @currentIndex++
      @showNextStep()

      if @currentIndex is @totalLength - 1
        @setState("touched")

  showNextStep: (withoutPrompt) ->
    steps = @getEl("steps").children
    step  = steps[@currentIndex]
    if (step?)
      @transformSteps()
    @setPrompt() unless withoutPrompt

  transformSteps: ->
    steps = @getEl("steps").children
    step  = steps[@currentIndex]
    step.classList.add("active")

    y = @el.offsetHeight / 2 - (step.offsetTop + step.offsetHeight / 2)

    @getEl("btn-up").style.opacity = @currentIndex / (@totalLength - 1)
    @getEl("btn-down").style.opacity = 1 - @currentIndex / (@totalLength - 1)

    if y < -@getEl("steps").firstChild.offsetHeight / 2
      @trigger "scroll", null, "middle"
    else
      @trigger "scroll", null, "top"

    for child, i in steps
      @transform child,
        transition: "all 900ms"
        opacity:
          if i <= @currentIndex then 1 - (@currentIndex - i) / @totalLength
          else 0

    @transform @getEl("steps"), { y }

  setPrompt: ->
    index = @currentIndex
    index += 1 unless @options.data.title
    preposition = i18n('text-sequence.of') || 'of'
    @getEl("prompt").innerHTML =
      if index > 0 or not @options.data.title
        """
          #{@options.data.label} #{index} #{preposition} #{@options.data.content.length}
        """
      else
        @options.data.prompt

  refresh: (params) ->
    for item, i in _.compact params.data.content
      changed = i if content and @options.data.content[i] isnt item

    if params.data.title isnt @options.data.title
      changed = -1

    super

    if changed?
      @beforeShow(true)
      @el.classList.add("no-transition")
      @onTap() while @currentIndex < changed
      window.setTimeout (=>
        @transition @getEl("steps"), "all 300ms"
        @el.classList.remove("no-transition")
      ), 1
    else
      @beforeShow()

  screenshot: ->
    @currentIndex = -1

    new Promise (resolve, reject) =>
      getPages = (images = []) =>
        if @currentIndex < @totalLength - 1
          @currentIndex++
          @showNextStep()
          @collateScreenshots(images)
            .then(getPages)
            .catch(reject)
        else
          resolve(images)

      getPages()

module.exports = TextSequenceView
